import script from "./RegisterInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterInfo.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterInfo.vue?vue&type=style&index=0&id=de6e82d4&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de6e82d4"]])

export default __exports__